import { useTranslation } from "react-i18next";
import { Dialog, DialogActions } from "@mui/material";
import { DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import ActionButton from "./ActionButton";
import { useEffect, useState } from "react";

interface IDeleteDialogProps {
  isOpen: boolean;
  title?: string;
  message?: string;
  actionBtnString?: string;
  onClickCloseOrCancel: any;
  onClickDelete: any;
}

const DeleteDialog = (props: IDeleteDialogProps) => {
  const { title, message, actionBtnString } = props;
  const { t } = useTranslation();
  const [actionProgress, setActionProgress] = useState(false);

  useEffect(() => {
    setActionProgress(false);
  }, [props.isOpen]);

  return (
    <Dialog
      open={props.isOpen}
      onClose={props.onClickCloseOrCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{t(title || "delete")}</DialogTitle>

      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {t(message || "areyouSureYouWantToDelete")}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <ActionButton
          color={actionBtnString ? "red" : "green"}
          onClick={() => {
            setActionProgress(false);
            props.onClickCloseOrCancel();
          }}
          label={t("cancel")}
        ></ActionButton>

        <ActionButton
          color={actionBtnString ? "green" : "red"}
          onClick={() => {
            setActionProgress(true);
            props.onClickDelete();
          }}
          autoFocus
          label={t(actionBtnString || "delete")}
          loading={actionProgress}
        ></ActionButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDialog;
